import { browser } from '../ws-hybrid';
import { load } from '../ws-util';
import { parseUrl } from '../ws-util/url';
import schema from '../ws-schema';

const CLIENT = browser.client;

function connectTenvideoJSBridge(callback) {
  if (window.TenvideoJSBridge) {
    console.log('connectTenvideoJSBridge');
    if (callback) {
      callback(window.TenvideoJSBridge);
    }
  } else {
    document.addEventListener('onTenvideoJSBridgeReady', () => {
      console.log('connectTenvideoJSBridge');
      if (callback) {
        callback(window.TenvideoJSBridge);
      }
    }, false);
  }
}

function connectSuperDownload(callback) {
  if (window.openDownloadApp) {
    console.log('window, openDownloadApp');
    callback(window.openDownloadApp);
  } else {
    schema.openDownloadApp.load();
    document.addEventListener('onSuperDownloadReady', () => {
      if (window.openDownloadApp) {
        console.log('document, ready, openDownloadApp');
        callback(window.openDownloadApp);
      } else {
        console.log('document, unready, openDownloadApp');
      }
    }, false);
  }
}

function getDateTime() {
  const current = new Date();
  const year = current.getFullYear();
  let month = current.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;
  let date = current.getDate();
  date = date < 10 ? `0${date}` : date;
  let hour = current.getHours();
  hour = hour < 10 ? `0${hour}` : hour;
  let minute = current.getMinutes();
  minute = minute < 10 ? `0${minute}` : minute;
  return `${year}-${month}-${date} ${hour}:${minute}`;
}

// 有opt优先用opt，没有就取url上的
function getReportParams(options) {
  const { params } = parseUrl(window.location.href);
  const newParams = Object.assign({}, params, options);
  const paramsArr = [];
  Object.keys(newParams || {}).forEach((item) => {
    paramsArr.push(`${item}=${newParams[item]}`);
  });
  if (paramsArr.length > 0) {
    return `&${paramsArr.join('&')}`;
  }
  return '';
}

function TencentVideoInitConfig(self, config) {
  connectTenvideoJSBridge();
  const initConfig = {
    reportID: config.pageID || config.reportID,
  };
  // eslint-disable-next-line no-param-reassign
  self.config = Object.assign(self.config || {}, initConfig);
}

function TencentVideoReport(type, options = {}) {
  const { params } = parseUrl(window.location.href);
  const paramsstr = getReportParams(options);

  // eslint-disable-next-line consistent-return
  connectTenvideoJSBridge(() => {
    const conf = {
      reportKey: params.scenes_source || options.pageID,
      eventName: type,
      reportParams: paramsstr,
    };
    console.log('tencentVideo doPRMTAReport conf', conf);

    if (!conf.reportKey || !conf.eventName) {
      console.log('tencentVideo doPRMTAReport 缺少参数');
      return '';
    }
    console.log('tencentVideo execute doPRMTAReport');

    window.TenvideoJSBridge.invoke('doPRMTAReport', conf);
  });
}

// QQ终端初始化JSbridge，主要适用看点
// QQ看点-上报接口文档：http://tapd.oa.com/TencentC2B/markdown_wikis/view/#1010096871008952881
const qqjsapi = '//qzonestyle.gtimg.cn/qzone/hybrid/lib/qqapi.js';

function KandianInitConfig(self, config) {
  const { params } = parseUrl(window.location.href);
  const isKandian = !!(params.kandian);
  if (isKandian && !window.mqq) {
    load.loadJs(qqjsapi);
  }
  const initConfig = {
    reportID: config.pageID || config.reportID,
  };
  // eslint-disable-next-line no-param-reassign
  self.config = Object.assign(self.config || {}, initConfig);
}

function KandianReport(type, options) {
  const { params } = parseUrl(window.location.href);
  const isKandian = !!(params.kandian);
  if (isKandian) {
    const doFun = function () {
      // eslint-disable-next-line no-shadow
      const { params } = parseUrl(window.location.href);
      const data = Object.assign({}, params, options);
      console.log('kandian reportKandian params', type, data);

      window.mqq.invoke('publicAccountNew', 'reportKandian', {
        op: type,
        bid: 'weishi',
        data: JSON.stringify(data) || '',
      }, (res) => {
        console.log('看点数据上报回调: ', res);
      });
    };

    if (window.mqq) {
      doFun();
    } else {
      load.loadJs(qqjsapi, doFun);
    }
  }
}

// 应用宝只有场景上报，没有点击上报，初始化即上报
const yybjsapi = '//qzs.qq.com/open/yyb/common/js/jsbridge.js?_ck_bid=2';

function YybInitConfig() {
  const doFun = function () {
    const { params } = parseUrl(window.location.href);
    if (params.scene) {
      console.log('应用宝 上报场景');
      window.JsBridge.call('setPageConfig', { scene: params.scene }, (res) => {
        console.log('setPageConfig success', res);
      });
    }
  };

  if (window.JsBridge) {
    doFun();
  } else {
    load.loadJs(yybjsapi, doFun);
  }
}

const clientMap = {
  tencentVideo: {
    initConfig: TencentVideoInitConfig,
    report: TencentVideoReport,
  },
  qq: {
    initConfig: KandianInitConfig,
    report: KandianReport,
  },
  yyb: {
    initConfig: YybInitConfig,
  },
};

const SoftInsideReport = {
  config: null,
  init(config) {
    if (clientMap[CLIENT]) {
      clientMap[CLIENT].initConfig(this, config);
      console.log(CLIENT, '上报初始化参数', this.config);
    }
  },
  // eslint-disable-next-line consistent-return
  report(type, opt) {
    console.log('当前客户端: ', CLIENT);
    if (clientMap[CLIENT] && clientMap[CLIENT].report) {
      const params = Object.assign({
        eventID: type,
        eventTime: getDateTime(),
        pageID: this.config.reportID,
      }, opt || {});
      return clientMap[CLIENT].report(type, params);
    }
  },
  reportPV(type, options) {
    let params = options;
    if (type && typeof type === 'object') {
      params = type;
    }
    if (CLIENT === 'qq') {
      this.report(3, params);
    } else if (CLIENT === 'tencentVideo') {
      this.report('exposure', params);
    }
  },
  reportDownload(type, params) {
    if (clientMap[CLIENT] && clientMap[CLIENT].report) {
      connectSuperDownload((superDownload) => {
        console.log('check is install weishi');
        superDownload.isAppInstall({
          cb: (state) => {
            if (state !== 'yes') {
              console.log(`${CLIENT} 客户端内软上报 点击`);
              console.log('not install weishi');
              if (CLIENT === 'qq') {
                this.report(1, params);
              } else {
                this.report(type, params);
              }
            }
          },
        });
      });
    }
  },
  reportClick(params) {
    if (clientMap[CLIENT] && clientMap[CLIENT].report) {
      console.log(`${CLIENT} 客户端内软上报 点击`);
      connectSuperDownload((superDownload) => {
        console.log('check is install weishi');
        superDownload.isAppInstall({
          cb: (state) => {
            if (state !== 'yes') {
              console.log('not install weishi');
              // 下载上报
              if (CLIENT === 'qq') {
                this.report(1, params);
              } else if (CLIENT === 'tencentVideo') {
                this.report('click_down', params);
              }
            } else {
              console.log('installed weishi');
              // 跳转到微视的上报，即拉活
              if (CLIENT === 'qq') {
                this.report(4, params);
              } else if (CLIENT === 'tencentVideo') {
                this.report('click_wake', params);
              }
            }
          },
        });
      });
    }
  },
};

export default SoftInsideReport;
